"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configuration_1 = require("@common/configuration");
const units_service_1 = require("./units.service");
class UnitsResRulesService extends units_service_1.UnitsService {
    constructor(token) {
        super(token);
        this.endpointBaseUrlV2 = configuration_1.Configuration.unitsServiceConfig().apiV2;
    }
    async getUnitResRules(uuid) {
        const response = await this.httpService.get(`${this.endpointBaseUrlV2}/unit-reservation-rules?filter[uuid]=${uuid}`, { headers: this.getHeaders() });
        response.data.data.map(async (x) => {
            x.attributes = await this.setAuditFields(x.attributes);
        });
        return response.data.data;
    }
    async getActiveUnitResRules(uuid) {
        const response = await this.httpService.get(`${this.endpointBaseUrlV2}/unit-reservation-rules?filter[uuid]=${uuid}&filter[is_active]=true`, { headers: this.getHeaders() });
        response.data.data.map(async (x) => {
            x.attributes = await this.setAuditFields(x.attributes);
        });
        return response.data.data;
    }
    async getRulesList() {
        const response = await this.httpService.get(`${this.endpointBaseUrlV2}/reservation-rules`, { headers: this.getHeaders() });
        return response.data.data;
    }
    async getRuleValuesByCode(code) {
        const response = await this.httpService.get(`${this.endpointBaseUrlV2}/reservation-rules?filter[code]=${code}`, { headers: this.getHeaders() });
        return response.data.data;
    }
    async createUnitRule(unitRule) {
        const response = await this.httpService.post(`${this.endpointBaseUrlV2}/unit-reservation-rules`, { data: unitRule }, { headers: this.getHeaders() });
        return response.data.data;
    }
    async updateUnitRule(id, unitRule) {
        const response = await this.httpService.patch(`${this.endpointBaseUrlV2}/unit-reservation-rules/${id}`, { data: unitRule }, { headers: this.getHeaders() });
        return response.data.data;
    }
    async deleteUnitRule(id) {
        const response = await this.httpService.delete(`${this.endpointBaseUrlV2}/unit-reservation-rules/${id}`, { headers: this.getHeaders() });
        return response.data.data;
    }
}
exports.UnitsResRulesService = UnitsResRulesService;
//# sourceMappingURL=units-res-rules.service.js.map